<template>
  <div class="row">
    <div class="col-md-6">
      <RegistrationDocumentBlockComponent
        :title="$t('registration.document.cerfa.title')"
        :baseline="$t('registration.document.baseline')"
        icon="file-lines"
        :fileModels="cerfaModels"
        @updateDocument="updateDocument('cerfa')"
        @download="download('cerfa')"
      />
    </div>
    <div class="col-md-6">
      <RegistrationDocumentBlockComponent
        :title="$t('registration.document.convention.title')"
        :baseline="$t('registration.document.baseline')"
        icon="file-plus"
        :fileModels="conventionModels"
        @updateDocument="updateDocument('convention')"
        @download="download('convention')"
      />
    </div>
  </div>
</template>

<script>
import RegistrationDocumentBlockComponent from "@/components/registration/document/RegistrationDocumentBlockComponent.vue";

export default {
  name: "RegistrationDocumentsListComponent",
  components: { RegistrationDocumentBlockComponent },
  props: {
    cerfaModels: {
      type: Object,
      required: true,
    },
    conventionModels: {
      type: Object,
      required: true,
    },
  },
  emits: ["updateDocument", "download"],
  data() {
    return {};
  },
  methods: {
    updateDocument(type) {
      this.$emit("updateDocument", type);
    },
    download(type) {
      this.$emit("download", type);
    },
  },
};
</script>

<style lang="scss" scoped></style>
